const Footer = () => {
    return (
        <div className="bg-dark mt-auto p-2 text-light text-center">
            This web app is a demo and should not be used beyond that of a demo.<br/> Made by: <a className="text-light" href="/">CEKlopfenstein</a>
        </div>
    )
}

export default Footer;